import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DataGridContainer from "../components/TourComponents/Desktop/DataGridContainer.tsx";
import TourCardList from "../components/TourComponents/Phone/TourCardList.tsx";

  const TourPage: React.FC = () => {
    const { pk } = useParams<{ pk?: string }>();
    const [isPhone, setIsPhone] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    const checkDeviceType = () => {
      const deviceWidth = window.innerWidth / window.devicePixelRatio;
      setIsPhone(deviceWidth <= 400);
      setIsTablet(deviceWidth > 400 && deviceWidth <= 1024);
    };

    useEffect(() => {
      checkDeviceType();
      window.addEventListener("resize", checkDeviceType);
      return () => window.removeEventListener("resize", checkDeviceType);
    }, []);

    if (!pk) {
        return <div>Error: No parent ID provided.</div>; // Handle missing pk case
      }

    return (
      <div>
        <div>
          {isPhone || isTablet ? (
            <TourCardList pk={pk} />
          ) : (
            <DataGridContainer pk={pk} />
          )}
        </div>
      </div>
    );
  };

  export default TourPage;